module.exports = __webpack_public_path__ + "img/ac220a54b814a46e24401fea61422fb7.png";